import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf44.png';

const MarketShareStep23 = (previousShownErrors) => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    previousShownErrors={previousShownErrors}
    alertText="Potential Demand Issue : You have a low ranking product"
    subTitle="Research &amp; Investigate"
    paragraph2={(
      <Fragment>
        To better understand your product’s ranking in relation to your competitors, we highly recommend you conduct Research and <span>review the Team Reports</span>, particularly the <span>Marketing Analysis (sub-section Customer Surveye)</span>.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep23;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step23.js